export default function (pairSeparator, fieldSeparator, source) {
    return source.split(pairSeparator).reduce((dictionary, stringChunk) => {
        const [key, value] = stringChunk.split(fieldSeparator);
        dictionary[key] = value;
        return dictionary;
    }, {});
} 
